import SearchResults from './search-results';

export default SearchResults;